import { pluckDeep as pluckDeep$1 } from './pluck-deep.js';
function getWidth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'width';
  var width = typeof value === 'number' ? value : pluckDeep$1(value, key);
  return width ? "".concat(width, "px") : "".concat(defaultWidth, "px");
}
export { getWidth };